import { Checkbox, InputAdornment, TextField, Typography } from "@mui/material";

type Props = {
	label: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
};

export const CheckboxTextField = ({
	label,
	checked,
	onChange,
	disabled = false,
}: Props) => {
	return (
		<TextField
			value=""
			fullWidth
			size="small"
			disabled={disabled}
			InputProps={{
				readOnly: true,
				startAdornment: (
					<InputAdornment position="start">
						<Typography
							variant="body2"
							color={disabled ? "text.disabled" : "text.secondary"}
							sx={{ userSelect: "none" }}
						>
							{label}
						</Typography>
					</InputAdornment>
				),
				endAdornment: (
					<InputAdornment position="end">
						<Checkbox
							checked={checked}
							onChange={(e) => onChange(e.target.checked)}
							disabled={disabled}
							size="small"
							sx={{ p: 0 }}
						/>
					</InputAdornment>
				),
				sx: {
					cursor: disabled ? "default" : "pointer",
					"& input": {
						cursor: disabled ? "default" : "pointer",
					},
				},
			}}
			onClick={() => {
				if (!disabled) {
					onChange(!checked);
				}
			}}
		/>
	);
};
